import {useCallback, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {t} from 'i18next';
import {Typography} from '@mui/material';
import {RootState} from '../../../../redux/store';
import AurButton from '../../../common/aur-button/AurButton';
import {ReactComponent as ExchangeIcon} from '../../../../assests/svg/icon_shift.svg';
import EvidenceSelectionDialog from './EvidenceSeelectionDialog/EvidenceSelectionDialog';
import {ReportScreenTabTypes} from '../../../pages/reports/ProjectOverview';
import AurHighlyConfidential from '../../../common/aur-highly-confidential/AurHighlyConfidential';
import {setReportSrc} from '../../../../redux/slices/analyticsSlice';
import {GA_REGIONS} from '../../../../constants/analyticsConstants';

interface Props {
  openSpecificTab?: (type: ReportScreenTabTypes) => void;
}

const ProcessingInProressHeader: React.FC<Props> = ({openSpecificTab}) => {
  const {
    mediaEvidenceId,
    mediaEvidenceName,
    selectedProjectName: projectName,
    selectedWorkSpaceName: workspaceName,
    workspaceId,
    currentProject: project,
  } = useSelector((state: RootState) => state.reports);
  const [evidenceDialogVisible, setEvidenceDialogVisible] =
    useState<boolean>(false);
  const dispatch = useDispatch();

  const handleIntakeTabClick = () => {
    dispatch(setReportSrc(GA_REGIONS.BODY));
    if (openSpecificTab)
      openSpecificTab(ReportScreenTabTypes.INTAKE_AUDIT_REPORT);
  };

  useEffect(() => {
    if (workspaceId === '') setEvidenceDialogVisible(true);
  }, []);

  const handleEvidenceSourceClick = useCallback(() => {
    setEvidenceDialogVisible(true);
  }, []);

  return (
    <div className="processing-in-progress-header">
      {project?.highlyConfidential && (
        <AurHighlyConfidential
          type="pill"
          showWarningText={true}
          className="highly-confidential-alert"
        />
      )}

      <Typography className="typo-text subhead3_size mist-100-text">
        {projectName}
      </Typography>

      <div className="workspace-name-button-row">
        <Typography className="typo-text display3_size">
          {workspaceName}
        </Typography>
        <AurButton
          ariaLabel={`${t('reports.processingInProgress.project')} | ${t('reports.processingInProgress.workspace')} | ${t('reports.processingInProgress.mediaEvidenceSet')}`}
          classNames="typo-text buttonMedium_size"
          type="continue"
          size="Medium"
          startIcon={<ExchangeIcon aria-hidden="true" />}
          onClick={handleEvidenceSourceClick}
          dataTestId="pick-media-id-button"
        >
          {t('reports.processingInProgress.project')}{' '}
          <span className="color-button-divider"> | </span>{' '}
          {t('reports.processingInProgress.workspace')}{' '}
          <span className="color-button-divider"> | </span>{' '}
          {t('reports.processingInProgress.mediaEvidenceSet')}
        </AurButton>
      </div>
      {mediaEvidenceId && mediaEvidenceName && (
        <Typography className="typo-text display3_size mist-100-text">
          {t('reports.processingInProgress.evidenceMediaCaptionWithID', {
            evidenceName: mediaEvidenceName ?? ' ',
            mediaId: mediaEvidenceId ?? '',
          })}
        </Typography>
      )}
      <div className="intake-source-row">
        <span className="typo-text subhead2_size">{t('common.source')}</span>
        <button
          title={t('reports.processingInProgress.intakeAuditReport')}
          aria-label="to view “Intake Audit Report”"
          className="typo-text subhead2_size link"
          onClick={handleIntakeTabClick}
        >
          {t('reports.processingInProgress.intakeAuditReport')}
        </button>
      </div>
      <EvidenceSelectionDialog
        isOpen={evidenceDialogVisible}
        onClose={() => setEvidenceDialogVisible(false)}
        onContinue={() => setEvidenceDialogVisible(false)}
      />
    </div>
  );
};

export default ProcessingInProressHeader;
